import AuthService from '@/packages/auth-service'
import store from '@/app/store'
import b2bApiClient from '@/shared/api/b2b-client'

class PartnerSettingsApiService {
  constructor() {
    this.client = b2bApiClient.getClient()
  }

  get _accessToken() {
    return store.state.auth.access_token || AuthService.getAccessToken()
  }

  get _headers() {
    return {
      'Content-Type': 'application/json',
      'x-access-token': this._accessToken,
    }
  }

  async getPartnerSettings(params) {
    return await this.client.get(
      `/processing/partner/settings`,
      params,
      this._headers
    )
  }
}

export const partnerSettingsApiService = new PartnerSettingsApiService()
export default partnerSettingsApiService
